import React, { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setIsDeleting } from '../../../../../../../actions/Notifications.actions';
import { Notification } from '../../../../../../../interfaces/Notification';
import { StyledCancel, StyledSection } from './Deleting.styles';

export interface DeletingProps {
  notification: Notification;
  onDeleted: () => void;
}

const Deleting: FC<DeletingProps> = ({ notification, onDeleted }) => {
  const { t } = useTranslation('Notifications');
  const dispatch = useDispatch();
  const ref = useRef<HTMLDivElement>();

  React.useEffect(() => {
    ref.current?.addEventListener('transitionend', onDeleted);
    setTimeout(() => {
      ref.current?.classList.add('notificationDeleting');
    }, 50);
  }, [notification.isDeleting, onDeleted]);

  if (!notification.isDeleting) return null;
  return (
    <StyledSection ref={ref}>
      <div>{t('deleted')}</div>
      <StyledCancel data-testid="cancelDelete" onClick={() => dispatch(setIsDeleting(notification.id, false))}>{t('cancel')}</StyledCancel>
    </StyledSection>
  );
};

export default Deleting;
